// extracted by mini-css-extract-plugin
export default {"root":"GroupRoyaltiesModal_root__4MD73","sub-header":"GroupRoyaltiesModal_sub-header__ByvWF"};